import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify)

export default new Vuetify({
  computed: {

  },
  icons: {
    iconfont: 'mdi'
  },
  theme: {
    options: { customProperties: true },
    dark: false,
    themes: {
      light: {
        whitetext: '#fff',
        btnlogout: '#FFFFFF',
        error: '#EF5350',
        info: '#219DAB',
        success: '#2E7D32',
        bgyellow: '#FFC328',
        menu: '#0E153A',
        primary: '#219DAB',
        second: '#195C76'
      }
    }
  }
})
